<template>
  <el-carousel :interval="5000" arrow="always">
    <el-carousel-item v-for="(item,index) in  bannerList" :key="index">
     <div class="ue-banner" @click="goPage(item.url)" :style="'background-image:url('+item.coverPhoto.url+')'">
     </div>
    </el-carousel-item>
  </el-carousel>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data(){
     return {
     };
  },
  computed: {
    ...mapGetters('home', ['bannerList'])
  },
  methods: {
    goPage(url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
  .ue-banner{
    height: 100%;
    width: 100%;
    border-radius: 6px;
    background-size: cover;
  }
</style>